import { MultimediaState } from '../../../../../@types/state-types'

export const multimediaOperationsToApi = (multimediaFeature: MultimediaState) => ({
  multimediaToDelete: multimediaFeature.multimediaToDelete,
  multimediaToUpdate: multimediaFeature.multimediaToUpdate,
})
